import { createBrowserHistory } from 'quartz-routing/react-router';
import { getPublicBasename } from '../utils/urls';
const history = createBrowserHistory({
  basename: getPublicBasename()
});
export function getHistory() {
  return history;
}